module.exports = __webpack_public_path__ + "static/media/26UNRWA16.d4866a3e.jpg";